import { render, staticRenderFns } from "./TenantLogin.vue?vue&type=template&id=563d9d74&scoped=true&"
import script from "./TenantLogin.vue?vue&type=script&lang=js&"
export * from "./TenantLogin.vue?vue&type=script&lang=js&"
import style0 from "./TenantLogin.vue?vue&type=style&index=0&id=563d9d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d9d74",
  null
  
)

export default component.exports